import { createModuleLayout } from "@/lib/create-module-layout";
import { MODULES } from "@kubdee/shared/module-ids";
import chatModule from "@kubdee/module-chat";

export default createModuleLayout({
  moduleId: MODULES.CHAT,
  moduleConfig: chatModule,
});
